import { inject, singleton } from "tsyringe";
import { AxiosAdapter } from "@/shared/libs/http/axios/AxiosFetcher";

// interface & type
import type { HttpAdapter } from "@/shared/libs/http/interface";

/** 구조체(axios) 변경 대비 layer 설정 */
@singleton()
export default class HttpAdapterImpl implements HttpAdapter {
    constructor(@inject(AxiosAdapter) private readonly axiosAdapter: AxiosAdapter) {}

    get<T>(url: string, signal?: AbortSignal): Promise<T> {
        return this.axiosAdapter.get<T>(url, signal);
    }

    post<T>(url: string, data?: any): Promise<T> {
        return this.axiosAdapter.post<T>(url, data);
    }

    patch<T>(url: string, data: any): Promise<T> {
        return this.axiosAdapter.patch<T>(url, data);
    }

    put<T>(url: string, data: any): Promise<T> {
        return this.axiosAdapter.put<T>(url, data);
    }

    delete<T>(url: string): Promise<T> {
        return this.axiosAdapter.delete<T>(url);
    }

    getInBff<T>(url: string, signal?: AbortSignal): Promise<T> {
        return this.axiosAdapter.getInBff<T>(url, signal);
    }

    postInBff<T>(url: string, data: any): Promise<T> {
        return this.axiosAdapter.postInBff<T>(url, data);
    }

    patchInBff<T>(url: string, data: any): Promise<T> {
        return this.axiosAdapter.patchInBff<T>(url, data);
    }

    getInLearnerAnalyzer<T>(url: string, signal?: AbortSignal): Promise<T> {
        return this.axiosAdapter.getInLearnerAnalyzer<T>(url, signal);
    }

    postInLearnerAnalyzer<T>(url: string, data: any): Promise<T> {
        return this.axiosAdapter.postInLearnerAnalyzer<T>(url, data);
    }
}
